import React, { useContext as useContextCore } from 'react'
import type { BomSummary } from '@ztechapps/product.common'
import type { UseErrorResult } from '@ztechapps/common.hook'
import { useError } from '@ztechapps/common.hook'

export type BuildButtonProviderProps = {
  children: React.ReactNode
} & BomSummary

export type BuildButtonContext = {
  useErrorResult: UseErrorResult
} & Omit<BuildButtonProviderProps, 'children'>

const context = React.createContext<BuildButtonContext>({} as BuildButtonContext)
const CoreProvider = context.Provider

export const BuildButtonProvider = ({ children, ...props }: BuildButtonProviderProps) => {
  const useErrorResult = useError()
  return (
    <CoreProvider
      value={{
        ...props,
        useErrorResult,
      }}
    >
      {children}
    </CoreProvider>
  )
}

export const useBuildButtonContext = () => useContextCore(context)
